import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap'
import { ReactComponent as DownloadIcon } from "Assets/icons/download.svg";
import API_BASE_URL from 'Components/API'

function DownloadLinkDirectly({ classList, fileUrl, linkText }) {
    const [loading, setLoading] = useState(false);
    const handleClick = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}/${fileUrl}`);
            const data = await response.json();
            if (data.results[0]) {
               
                const blob = await fetch(`data:${data.results[0].contentType};base64,${data.results[0].fileContent}`).then(res => res.blob());
                const downloadUrl = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', data.results[0].fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }
            setLoading(false);
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

                return (
                    <React.Fragment>

                        <a onClick={handleClick} className={classList} >
                            {linkText} <span><DownloadIcon /></span>
                            {loading ? <Spinner
                                as="span"
                                variant="primary"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                animation="border" /> : ''}
                        </a>
                    </React.Fragment>
                )

}
export default DownloadLinkDirectly